export const tiposAditivo = [
    { value: 1, text: 'Acréscimo/Supressão' },
    { value: 2, text: 'Prazo' },
    { value: 3, text: 'Reajuste Financeiro ou Repactuação' },
    { value: 4, text: 'Renovar prazo e valor' },
    { value: 5, text: 'Reajuste Financeiro e Prazo' }
]